import {WebConferenceJoinResultInterface} from "@api/models/interfaces/web-conference/WebConferenceJoinResultInterface";
import {AgoraCredentials} from "@api/models/web-conferences/AgoraCredentials";
import {WebConferenceTypes} from "@share/web-conferences/enums/WebConferenceTypes";
import {UserRoleType} from "@share/web-conferences/enums/UserRoleType";
import {getUserIdFromUid} from "@share/web-conferences/helpers/UserIdHelper";
import {UID} from "agora-rtc-sdk-ng";
import {isPresenter as isPresenterHelper} from "@share/web-conferences/helpers/UserRoleHelper";
import {CurrentPresentation} from "@api/models/interfaces/web-conference/CurrentPresentation";
import {SharingTypes} from "@api/enums/WebConferenceSlides/SharingTypes";
import { LiveKitCredentials } from "@api/models/web-conferences/LiveKitCredentials";

export class WebConferenceJoinResult implements WebConferenceJoinResultInterface {
    agoraCredentials: AgoraCredentials;
    currentPresentation: CurrentPresentation |  null;
    type: WebConferenceTypes;
    userRole: UserRoleType;
    liveKitCredentials: LiveKitCredentials;
    isBeginRecorded: boolean;
    recordingUserIds: number[] = [];

    constructor(data: WebConferenceJoinResultInterface) {
        Object.assign(this, data);
        if (data.agoraCredentials) {
            this.agoraCredentials = new AgoraCredentials(data.agoraCredentials);
        }

        if (data.liveKitCredentials) {
            this.liveKitCredentials = new LiveKitCredentials(data.liveKitCredentials);
        }
    }

    userId(): number {
        if (this.agoraCredentials) {
            return getUserIdFromUid(this.agoraCredentials.userId as UID);
        }

        if (this.liveKitCredentials) {
            return this.liveKitCredentials.userId;
        }

        return 0;
    }

    isPresenter(): boolean {
        return isPresenterHelper(this.userRole);
    }

    sharingCredentialsEmpty() {
        return !this.agoraCredentials.screenSharingUserId;
    }

    hasSharingType(type: SharingTypes) {
        return this.currentPresentation && this.currentPresentation.type == type;
    }

    isSharingUser(userId: number) {
        return this.currentPresentation && this.currentPresentation.userId == userId;
    }

    isSharing() {
        return Object.keys(this.currentPresentation ?? {}).length > 0;
    }
}
